import apiClient from "@/api/client";
import type { Asset, Branch, HandoverProtocol } from "../types";

export interface PickerUser {
  id: string;
  first_name: string;
  last_name: string;
}

export const assetsApi = {
  list: (params?: Record<string, string>) =>
    apiClient.get<{ data: Asset[] }>("/assets/", { params }).then((r) => r.data.data),

  assignable: () =>
    apiClient.get<{ data: Asset[] }>("/assets/assignable/").then((r) => r.data.data),

  create: (data: { name: string; description?: string; visibility?: string; branch?: string }) =>
    apiClient.post<{ data: Asset }>("/assets/", data).then((r) => r.data.data),

  update: (id: string, data: Partial<Pick<Asset, "name" | "description" | "visibility">>) =>
    apiClient.patch<{ data: Asset }>(`/assets/${id}/`, data).then((r) => r.data.data),

  delete: (id: string) => apiClient.delete(`/assets/${id}/`),

  assign: (id: string, data: { employee: string; handover_date?: string }) =>
    apiClient.post<{ data: Asset }>(`/assets/${id}/assign/`, data).then((r) => r.data.data),

  unassign: (id: string) =>
    apiClient.post<{ data: Asset }>(`/assets/${id}/unassign/`, {}).then((r) => r.data.data),

  setVisibility: (id: string, visibility: string) =>
    apiClient
      .post<{ data: Asset }>(`/assets/${id}/set_visibility/`, { visibility })
      .then((r) => r.data.data),

  transfer: (id: string, branch: string) =>
    apiClient
      .post<{ data: Asset }>(`/assets/${id}/transfer/`, { branch })
      .then((r) => r.data.data),
};

export const pickersApi = {
  users: () => apiClient.get<{ data: PickerUser[] }>("/users/").then((r) => r.data.data),
  branches: () => apiClient.get<{ data: Branch[] }>("/auth/branches/").then((r) => r.data.data),
};

export const protocolsApi = {
  list: (params?: Record<string, string>) =>
    apiClient
      .get<{ data: HandoverProtocol[] }>("/handover-protocols/", { params })
      .then((r) => r.data.data),

  create: (formData: FormData) =>
    apiClient
      .post<{ data: HandoverProtocol }>("/handover-protocols/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data.data),

  approve: (id: string, comment?: string) =>
    apiClient
      .post<{ data: HandoverProtocol }>(`/handover-protocols/${id}/approve/`, { comment: comment ?? "" })
      .then((r) => r.data.data),

  reject: (id: string, comment: string) =>
    apiClient
      .post<{ data: HandoverProtocol }>(`/handover-protocols/${id}/reject/`, { comment })
      .then((r) => r.data.data),

  generatePdf: (items: string[]) =>
    apiClient.post("/handover-protocols/generate_pdf/", { items }, { responseType: "blob" }),

  pendingCount: () =>
    apiClient
      .get<{ data: number }>("/handover-protocols/pending-count/")
      .then((r) => r.data.data),
};
